import {IOption} from "@pg-design/select-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {buildFriendlyPromotionSlug} from "../../promotion/helpers/build_friendly_promotion_slug";
import {SortValue} from "../constants/offer_list";

export const getMoreOffersLink = (regionValue: IOption & {slug: string}, sortValue: string) => {
    if (sortValue === SortValue.PROMOTED) {
        return rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: regionValue.slug})});
    }

    if (sortValue === SortValue.RATING) {
        return rpAppLink.ranking.base() + regionValue.slug;
    }

    // ?sort=2
    if (sortValue === SortValue.CREATE_DATE) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug}).friendlySlug}) + "?sort=2";
    }

    // gotowe-*
    if (sortValue === SortValue.CONSTRUCTION_DATE_RANGE) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug, construction_end_date: "0"}).friendlySlug});
    }

    // tanie-*
    if (sortValue === SortValue.PRICE_M2) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug, price_lower_than_average: true}).friendlySlug});
    }

    return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug}).friendlySlug});
};
import {IOption} from "@pg-design/select-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {buildFriendlyPromotionSlug} from "../../promotion/helpers/build_friendly_promotion_slug";
import {SortValue} from "../constants/offer_list";

export const getMoreOffersLink = (regionValue: IOption & {slug: string}, sortValue: string) => {
    if (sortValue === SortValue.PROMOTED) {
        return rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: regionValue.slug})});
    }

    if (sortValue === SortValue.RATING) {
        return rpAppLink.ranking.base() + regionValue.slug;
    }

    // ?sort=2
    if (sortValue === SortValue.CREATE_DATE) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug}).friendlySlug}) + "?sort=2";
    }

    // gotowe-*
    if (sortValue === SortValue.CONSTRUCTION_DATE_RANGE) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug, construction_end_date: "0"}).friendlySlug});
    }

    // tanie-*
    if (sortValue === SortValue.PRICE_M2) {
        return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug, price_lower_than_average: true}).friendlySlug});
    }

    return rpAppLink.offer.listFriendly({friendlySlug: offerUrlBuilder({region: regionValue.slug}).friendlySlug});
};
